import { createActionTypes } from 'actionCreators';

export const SIGN_IN_REQUEST = 'SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILED = 'SIGN_IN_FAILED';

export const SIGN_IN = createActionTypes('SIGN_IN');
export const RESET_PASSWORD = createActionTypes('RESET_PASSWORD');
export const CONFIRM_PASSWORD_RESET = createActionTypes('CONFIRM_PASSWORD_RESET');
export const FETCH_ME = createActionTypes('FETCH_ME');

export const SIGN_OUT = 'SIGN_OUT';
// Outlasts galaxy-server's 5s auth-server bound so its cookie clear lands.
export const SIGN_OUT_REQUEST_TIMEOUT_MS = 8_000;

export const RESET_AUTH = 'RESET_AUTH';

export enum RedirectKeys {
  AccessToken = 'access_token',
}

/**
 * GLX-1743: fail over instead of leaving users stuck on the
 * "Authenticating" screen.
 */
export const AUTH_WATCHDOG_TIMEOUT_MS = 20_000;
export const AUTH_FAILURE_REDIRECT_DELAY_MS = 3_000;
